import { DefaultCreateLabelWrapper, SecondaryText } from './Select.styles';

type DefaultCreateLabelProps = {
  inputValue: string;
  createPrefix: string;
  createSuffix: string;
};

export const DefaultCreateLabel = ({
  inputValue,
  createPrefix,
  createSuffix,
}: DefaultCreateLabelProps) => (
  <DefaultCreateLabelWrapper data-test="default-create-label">
    <SecondaryText>{createPrefix}</SecondaryText>
    {inputValue}
    <SecondaryText> {createSuffix}</SecondaryText>
  </DefaultCreateLabelWrapper>
);
